import _taggedTemplateLiteral from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: 20px;\n  border-radius: ", "px;\n  background-color: ", ";\n  &:not(:last-child) {\n    margin-right: ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { animated } from "react-spring";
import styled from "styled-components";
import { size, colors } from "../../../shared/constants";
var Chip = styled(animated.div)(_templateObject(), size.xs2, size.xs2, colors.green2, size.xs2);
export { Chip };